import { cx } from "@jugl-web/utils";
import { FC } from "react";

export const Separator: FC<{ className?: string }> = ({ className }) => (
  <div className={cx("h-px w-full shrink-0 bg-[#F2F2F2]", className)} />
);
